import './contact.css';
import rust from '../assets/rust-brands.svg'
function About() {
  return (
    <section
      data-aos="zoom-in"
      className="contact-container"
      name="contact"
      id="contact"
    >
      <div className="profile-image">

      </div>
      <h1 className="heading">Contact Me</h1>

      <div className="cards-container">
        {/* Card 1 - Email */}
        <div className="cards">
          <div className="contact-icons">
          <a href="mailto:syedusamalearner@gmail.com">  <i className="fas fa-envelope"></i></a>
          
          </div>
          <div className="contact-text">
            <span>Email</span>
          </div>
          <div className="contact-links">
            <span>syedusamalearner@gmail.com</span>
          </div>
        </div>

        {/* Card 2 - Social Media */}
        <div className="cards">
          <div className="contact-icons">
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <i className="fas gg fa-globe"></i>
          </div>
          <div className="contact-text">
            <span>Social Media</span>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
          <div className="contact-links">
            {/* github */}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://github.com/usamalearner"
            >
              <i className="fab fa-github" title="github" id="github"></i>
            </a>

            {/* facebook */}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.facebook.com/profile.php?id=100037959242670"
            >
              <i className="fab fa-facebook" title="facebook" id="facebook"></i>
            </a>

            {/* linkedIn */}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.linkedin.com/in/syedusama-ali"
            >
              <i className="fab fa-linkedin" title="linkedin" id="linkedin"></i>
            </a>

            {/* Twitter */}
            {/* <a
              rel="noopener noreferrer"
              target="_blank"
              href=""
            >
              <i className="fab fa-twitter" title="twitter" id="twitter"></i>
            </a> */}

            {/* Instagram */}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.instagram.com/syedusama.ali.790/"
            >
              <i
                className="fab fa-instagram"
                title="instagram"
                id="instagram"
              ></i>
            </a>
          </div>
        </div>

        {/* Card 3 - Phone */}
        <div className="cards">
          <div className="contact-icons">
            <i className="fas fa-phone"></i>
          </div>
          <div className="contact-text">
            <span>Phone</span>
          </div>
          <div className="contact-links">
            <span>(+92) 3451972784 </span>
          </div>
        </div>
      </div>
            <br/>
            <h2 style={{fontFamily:'Aladin'}}> “I don't just build websites, I build websites that Sells”</h2>
            <br/>
      <div className="thanks">
            
     
     
      <br/>
        <i className="fab javascript fa-js"></i>
        &nbsp;{" "}
         document.write("Thank You for visiting");
         <br/>
         <i class="fab node fa-node"></i> {"  "}
         console.log("Thank You for visiting");
         <br/>
         <img className="rust" width='20'  src={rust} alt=""/> &nbsp;
        println!("Thank You for visiting"); 
        <br/>
        <i className="fab python fa-python"></i> &nbsp;
        print("Thank You for visiting")
        <br/>
        <br/>
      </div>
    </section>
  );
}

export default About;